import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatSort, Sort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {FormControl} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {TableControl} from '../../../../../common/models/TableControl';
import {DateUtil} from '../../../../../common/util/DateUtil';
import {PagedRequestDTO} from '../../../../../common/models/PagedRequestDTO';
import {DisplayIcon} from 'src/app/modules/common/components';
import {MasterDrugService} from '../../../../services/master-drug.service';
import {MasterDrugDTO} from '../../../../models/MasterDrugDTO';
import {
  ConfirmationDialogComponent
} from '../../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';

import {detailsExpand} from '../../../../../common';
import {createFieldMap, getSortDirection} from '../../../../../common/util/Util';
import {SharedService} from '../../../../../common/services/shared-service';
import {EntityTable} from '../../../../../common/types/entity-table.enum';

@Component({
  selector: 'app-master-drugs',
  templateUrl: './master-drugs.component.html',
  styleUrls: [
    '../../../../../../../styles/global/_management-styles.scss'
  ],
  animations: [detailsExpand]
})
export class MasterDrugsComponent implements OnInit, AfterViewInit {
  readonly DisplayIcon = DisplayIcon;

  masterDrugFormControl: FormControl;
  masterDrugDataSource: MasterDrugDTO[];
  masterDrugDisplayedColumns: string[] = [
    'icons',
    'masterDrugId',
    'name',
    'dosageForm',
    'startDate',
    'endDate'
  ];
  masterDrugTableControl: TableControl;
  masterDrugExpandedRow: MasterDrugDTO | null;

  isConfirmed = false;
  dateFormat = DateUtil.dateFormat;
  dateTimeFormat = DateUtil.dateTimeFormat;
  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  @ViewChild('masterDrugSort', {static: false}) masterDrugSort: MatSort;
  @ViewChild('matSort', {static: false}) tableSort: MatSort;
  @ViewChild('masterDrugPaginator', {static: false}) masterDrugPaginator: MatPaginator;
  @ViewChild('masterDrugSearch') private masterDrugSearch: ElementRef;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private sharedService: SharedService,
    private masterDrugService: MasterDrugService,
  ) {
    this.masterDrugFormControl = new FormControl('');
    this.masterDrugTableControl = new TableControl(
      this.length,
      this.pageSize,
      this.pageNumber,
      this.pageSizeOptions,
      'masterDrugId',
      'desc',
      'name',
      ''
    );
  }

  ngOnInit(): void {
    this.getListOfMasterDrugs(this.masterDrugTableControl);
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.masterDrugSearch.nativeElement.focus(), 0);
  }

  getListOfMasterDrugs(tableControl: TableControl): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblMasterDrug;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = getSortDirection(
      tableControl.sortDirection
    );
    pagedRequestDTO.fieldMap = createFieldMap(
      tableControl.filterField,
      tableControl.filterValue
    );

    this.masterDrugService.getListOfMasterDrugs(pagedRequestDTO).subscribe(
      (response) => {
        this.masterDrugDataSource = response.resultList;
        this.masterDrugTableControl.length = response.totalRecords;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  pageChanged($event: PageEvent) {
    this.masterDrugTableControl.pageNumber = $event.pageIndex;
    this.masterDrugTableControl.pageSize = $event.pageSize;
    this.getListOfMasterDrugs(this.masterDrugTableControl);
  }

  sortData($event: Sort) {
    if (this.masterDrugPaginator != null) {
      this.masterDrugPaginator.firstPage();
    }
    this.masterDrugTableControl.pageNumber = 0;
    this.masterDrugTableControl.sortField = $event.active;
    this.masterDrugTableControl.sortDirection = $event.direction;
    this.getListOfMasterDrugs(this.masterDrugTableControl);
  }

  onInputChangedFilterData(filterField: string) {
    if (this.masterDrugPaginator != null) {
      this.masterDrugPaginator.firstPage();
    }
    this.masterDrugTableControl.pageNumber = 0;
    this.masterDrugTableControl.filterField = filterField;
    this.masterDrugTableControl.filterValue = this.masterDrugFormControl.value;
    this.getListOfMasterDrugs(this.masterDrugTableControl);
  }

  deleteEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: 'Are you sure you wish to delete this entity?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      const isConfirmed = result;

      if (isConfirmed) {
        this.masterDrugService.deleteMasterDrug(id).subscribe(
          () => {
            this.sharedService.openSnackBar(`Master Drug ${id} deleted`, 'Dismiss');
            this.getListOfMasterDrugs(this.masterDrugTableControl);
          },
          (errorResponse) => {
            const error = errorResponse.error;
            this.sharedService.openErrorDialog(error.businessMessage);
          }
        );
      }
    });
  }

  editEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    this.router.navigate(['/pharmacy-management/edit-master-drug/' + id]);
  }
}
